import Vue from 'vue';
import Router from 'vue-router';
import SinglePlayer from './components/SinglePlayer.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'single-player',
      component: SinglePlayer,
    },
    {
      path: '/play',
      name: 'single-player-play',
      component: SinglePlayer,
    },
  ],
});
